import AvatarMini from "components/commons/AvatarMini"
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom"
import { calculateAgeFromBirthDateEpochSeconds } from "utility/CalculateAge"

export const HealthPatientCard = ({
    patient
}) => {

    const [t] = useTranslation(["global", "health"]);

    const getFeatureLabel = (featureName) => {
        switch (featureName) {
            case "HR-SAFEZONE": return <><i className="fa-solid fa-heart-pulse opacity-25"></i> {t("health:entity.profile.features.HR-SAFEZONE")}</>
            case "FALL-DETECTION": return <><i className="fa-solid fa-person-falling opacity-25"></i> {t("health:entity.profile.features.FALL-DETECTION_short")}</>
            case "INACTIVITY": return <><i className="fa-solid fa-notes-medical opacity-25"></i> {t("health:entity.profile.features.INACTIVITY_short")}</>
            case "HR": return <><i className="fa-solid fa-chart-line opacity-25"></i> {t("health:entity.profile.features.HR")}</>
            case "STEPS": return <><i className="fa-solid fa-shoe-prints opacity-25"></i> {t("health:entity.profile.features.STEPS")}</>
            case "TEMPS": return <><i className="fa-solid fa-temperature-three-quarters opacity-25"></i> {t("health:entity.profile.features.TEMPS")}</>
            case "VO2MAX": return <><i className="fa-solid fa-lungs opacity-25"></i> {t("health:entity.profile.features.VO2MAX")}</>
            default: return featureName
        }
    }

    return <div className="card mt-2 bg-black bg-opacity-10  text-white p-4">
        <div className="row">
            <div className="col-lg-6">
                <div className="container mt-4">
                    <AvatarMini guid={patient.user.guid} displayName={patient.user.displayName} />
                </div>
                {
                    <div className="container row mt-4">
                        <span className="h5">{t("health:entity.patient.props.infos")}:</span>

                        <div className="col-auto text-muted">
                            <div className="p-1">{t("health:entity.patient.props.gender")}</div>
                            <div className="p-1">{t("health:entity.patient.props.birthday")}</div>
                            <div className="p-1 mt-1">{t("health:entity.patient.props.age")}</div>
                            <div className="p-1">{t("health:entity.patient.props.weight")}</div>
                            <div className="p-1">{t("health:entity.patient.props.height")}</div>
                        </div>
                        <div className="col">
                            <div className="p-1 text-muted" ><span >{patient.info.gender || "-"}</span></div>
                            <div className="p-1 text-muted" ><span >{patient.info.birthDate ? new Date(patient.info.birthDate * 1000).toLocaleDateString() : "-"}</span></div>
                            <div className="p-1 mt-1"><span className="h5">{patient.info.birthDate ? calculateAgeFromBirthDateEpochSeconds(patient.info.birthDate) : "-"}</span> {t("unit.years_other")}</div>
                            <div className="p-1"><span className="h5">{patient.info.weight || "-"}</span> kg</div>
                            <div className="p-1"><span className="h5">{patient.info.height || "-"}</span> cm</div>
                        </div>

                    </div>
                }

            </div>
            <div className="col-lg-6">
                {

                    <div className="container mt-4">
                        <div className="row align-items-center">
                            <div className="col-auto h5">{t("health:entity.profile.props.name")}:</div>
                            <div className="col"><NavLink to={"/dashboard/health/profiles"}><button className="btn btn-dark  ">{patient.profile.name}</button></NavLink></div>
                        </div>
                        {patient.profile.features.map(feature => (
                            <div className="row bg-dark p-1 my-2 rounded-pill">
                                <div className="col-4">
                                    {getFeatureLabel(feature.name)}
                                </div>
                                <div className="col">
                                    <div className="form-check form-switch">
                                        <input readOnly className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" checked={feature.enabled} />
                                    </div>
                                </div>
                                {
                                    feature.name === "HR-SAFEZONE" &&
                                    <>
                                        <div className="col text-secondary">
                                            <small>min</small>  {feature.enabled ? feature.settings.min : "-"}
                                        </div>
                                        <div className="col text-secondary">
                                            <small>max</small> {feature.enabled ? feature.settings.max : "-"}
                                        </div>
                                    </>
                                }
                                {
                                    feature.name === "FALL-DETECTION" &&
                                    <>

                                        <div className="col text-secondary">
                                            {feature.enabled ? <>{feature.settings.threshold} <small>m/s^2</small></> : "-"}
                                        </div>
                                        <div className="col text-secondary">
                                        </div>
                                    </>
                                }
                                {
                                    feature.name === "INACTIVITY" &&
                                    <>
                                        <div className="col text-secondary">
                                            {feature.enabled ? <>{feature.settings.threshold} <small>m/s^2</small></> : "-"}
                                        </div>
                                        <div className="col text-secondary">
                                        </div>

                                    </>
                                }

                            </div >
                        ))
                        }
                        <div className="row bg-black bg-opacity-25 p-1 my-2 rounded-pill">
                            <div className="col-4">
                                <i className="fa-solid fa-phone opacity-50"></i> {t("health:entity.profile.props.emergency_phone")}
                            </div>
                            <div className="col">
                                {patient.profile.emergencyNumber}
                            </div>

                        </div >
                    </div>
                }
            </div>
        </div>

    </div>

}